import { Center, Loader } from "@mantine/core";

export const CenteredLoader = () => (
    <Center w="100%" h="100%">
        <Loader />
    </Center>
);
